import { selectClasses } from '@mui/joy/Select';

export const defaultStyle = {
  height: 40,
  width: 240,
  zIndex: 1300,
  [`& .${selectClasses.indicator}`]: {
    transition: '0.2s',
    [`&.${selectClasses.expanded}`]: {
      transform: 'rotate(-180deg)',
    },
  },
};
